import React from "react";
import { CardContent, Typography, Box, Stack, Divider } from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import NumbersIcon from "@mui/icons-material/Numbers";
import { SequenceResponseDto } from "../../shared/dtos/sequence/SequenceResponseDto";

interface SequenceCardProps {
  sequence: SequenceResponseDto;
}

const SequenceCard: React.FC<SequenceCardProps> = ({ sequence }) => {
  return (
    <StyledCard>
      <CardContent>
        <Stack
          sx={{ flexDirection: "row", alignItems: "center", gap: 1.5, mb: 1 }}
        >
          <NumbersIcon />
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {sequence.documentType.replace(/_/g, " ")}
          </Typography>
        </Stack>
        <Divider sx={{ my: 1.5 }} />

        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Prefix
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {sequence.prefix}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Current Value
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", color: "secondary.main" }}
          >
            {sequence.currentValue}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Branch
          </Typography>
          <Typography variant="body2">{sequence.branchName}</Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default SequenceCard;
